module.exports = __webpack_public_path__ + "public/Icons/defaultImage.svg?03c3fd62";